import { DefaultService as UserInputSDK } from '@atbay/user-input-service-node-sdk'
import { createClient } from '@core/base/http-client'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const UserInputClient = createClient(UserInputSDK)
